import api from '../api'

export default {
    namespaced: true,
    state: {
        mtt:{
            mttList: [],
            mttListTotal: 0,
        },
        mttDetail:{
            "advancedEntryTimes": 0,
            "allowDelayMaxBlindLevel": 0,
            "allowRebuyMaxBlindLevel": 0,
            "allowRebuyTimes": 0,
            "blindType": 0,
            "creatorID": 0,
            "creatorName": "",
            "entryTime": "",
            "gameIcon": "",
            "gameType": 0,
            "huntsmanBonusPercent": 0,
            // "initialChip": 0,
            "initialScore": 0,
            "isAllowAppend": 0,
            "isAllowDelay": 0,
            "isAllowRebuy": 0,
            "isGpsLimit": 0,
            "totalRegistationFee":0,
            "isHuntsmanMatch": 0,
            "isIpLimit": 0,
            "isVirtual": 0,
            "lowerLimitPlayers": 0,
            "matchName": "",
            "prizeIcon": "",
            "prizeName": "",
            "registationFee": 0,
            "roomNumType": 9,
            "sbChip": 0,
            "serviceFee": 0,
            "showTime": "",
            "startTime": "",
            "updateBlindTime": 0,
            "upperLimitPlayers": 0,
            "voucherId": 0,
            "blindTypeLabel":'快速盲注表',
            'participateNum':0,
            "totalBonus":0
        },
        player:{
            list:[],
            totalPage: 0
        }
    },
    mutations: {
        setDataMttList(state, info) {
            state.mtt.mttList = info.beanList;
            state.mtt.mttListTotal = info.total
        },
        setDataMttDetail(state, info) {
            state.mttDetail = info;
        },
        setDataMttPlayer(state, info) {
            state.player.list = info.beanList;
            state.player.totalPage = info.total;
        }
    },
    actions: {
        createMttApi({commit}, params) {
            return api.post('/mtt/create', '创建mtt', params).then(res => {
                // commit('setDataMttBannerList', res.data)
            })
        },
        mttMangZhuList(){
            return api.post('/mangZhuGrade/listAll');
        },
        mttViewAtCount({commit},aiType){
            return api.post(`/mtt/view/aiCount/${aiType}`, '机器人数量');
        },
        mttListApi({commit}, params) {
            return api.post('/mtt/list', '赛事列表', params).then(res=>{
                // dispatch('getBannerList',{type:params.type})
                commit('setDataMttList', res.data)
            })
        },
        mttDetailApi({commit}, params) {
            return api.post('/mtt/detail', '比赛详情', params).then(res=>{
                commit('setDataMttDetail', res.data)
            })
        },
        disMttApi({dispatch}, params) {
            return api.post('/mtt/cancel', '取消/解散Mtt', params).then(()=>{
                // dispatch('getBannerList',{page,type})
            })
        },
        mttPlayerLApi({commit}, params) {
            return api.post('/mtt/players/detail', '获取玩家列表', params).then(res=>{
                commit('setDataMttPlayer', res.data)
            })
        }
    }
}